angular.module('rjmNg.directives').directive "notification", [
  "notification"
  "$http"
  "$templateCache"
  "$compile"
  "$timeout"
  (notification, $http, $templateCache, $compile, $timeout) ->
    templateLoader = null

    scope:
      template: "@"
      contact: "="
    restrict: "A"
    templateUrl: 'template.notification.html'
    compile: (tElement, tAttrs, transclude) ->
      #Use a custom template if one is provided
      if tAttrs.template?
        return (scope, element, attrs) ->
          #first wait for the template attribute to be evaluated
          attrs.$observe "template", (value) ->
            #Go and fetch the template
            templateLoader = $http.get(value, {cache: $templateCache})
              .then ({data}) ->
                tElement.html(data)
            #Assign the template to the directive
            templateLoader.then (templateText) ->
              element.html($compile(tElement.html())(scope))
    controller: [
      "$scope"
      "$element"
      "$attrs"
      ($scope, $element, $attrs) ->
        $scope.notificationClass = $attrs.notificationClass
        notificationScope = $attrs.notificationScope ? 'global'
        $scope.queue = notification.createQueue(notificationScope)
        $scope.removeNotification = (noti) ->
          $element.fadeOut 500, ->
            notification.remove(noti, notificationScope)
            $timeout ->
              $element.fadeIn 500
            , 100
          return
    ]
]
